import React, { Component } from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';


class Loading extends Component {
render () { 
    return (
        <Box sx={{mt: 4, mb: 4, p: 2, width: '100%' }}>
        <Skeleton />
        <Skeleton animation="wave" />
        <Skeleton animation={false} />
        </Box>
    );
    }
}

export default Loading
